import { useMemo } from 'react';
import { useRoutesContext } from '../index';

import { Station } from 'dataSources/Typicode/stations/types/station';

export const useActiveRouteRoadsideServicesStations = () => {
  const {
    routeRoadsideServicesStations,
    activeRoute
  } = useRoutesContext();

  const activeRouteRoadsideServicesStations = useMemo(() => (
    Object.keys(routeRoadsideServicesStations).reduce((acc, serviceId) => {
      if (activeRoute) {
        acc[serviceId] = routeRoadsideServicesStations[serviceId][activeRoute.id];
      }
      return acc;
    }, {} as { [serviceId: string]: Station[]; })
  ), [
    routeRoadsideServicesStations,
    activeRoute
  ]);

  return activeRouteRoadsideServicesStations;
};
